import React, { useEffect } from "react";
import { useParams, Link, useLocation } from "react-router-dom";
import Slider from "react-slick";
import SvgShikshaFlower from "../shiksha logo_flower_png.svg";
import Breadcrumb from "./Breadcrumb";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import "../../index.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const LeadershipDetails = ({ leadershipData, currentLanguage }) => {
  const { leaderId } = useParams();
  const leader = leadershipData.find(
    (e) => e.path.split("/").pop() === leaderId
  );

  const location = useLocation();

  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo(0, 0);
  }, [location]);

  if (!leader) return <div>Leader not found</div>;

  const uniqueTitles = new Set();

  // Settings for react-slick slider
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 3 },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className="relative z-0">
      <div className="relative">
        {leader.commonBanner?.mediaImage2 && (
          <img
            src={leader.commonBanner.mediaImage2.url}
            className="w-full object-cover lg:mt-[48px] h-[173px]"
            alt={leader.commonBanner.mediaImage2.alt}
          />
        )}
        <div className="absolute bottom-0 left-0 right-0 bg-[rgba(0,0,0,0.3)] p-2 sm:p-4">
          <Breadcrumb />
        </div>
      </div>

      <div className="container mx-auto px-4 md:px-8 lg:px-12 xl:px-20 max-w-screen-xl mt-6">
        <div className="flex flex-col sm:flex-row items-center mb-[35px]">
          <div className="right-border-around relative w-[250px] mr-[40px] pt-15 pr-15 pb-0 pl-0">
            {leader.imageAbout?.url && (
              <img
                src={leader.imageAbout.url}
                alt={leader.imageAbout.alt}
                className="relative w-full z-10"
              />
            )}
          </div>
          <Helmet>
            <title>{leader.title}</title> {/* Set dynamic title here */}
          </Helmet>
          <h1 className="font-heading font-bold">
            <strong className="block text-[22px] mb-[10px]">
              {leader.title}
            </strong>
            <span className="text-base font-body font-medium mt-1 block text-gray-700 h-auto overflow-hidden">
              {leader.post}
            </span>
            <p className="text-sm font-body text-gray-500 dark:text-gray-400">
              {leader.shortDescription}
            </p>
          </h1>
        </div>
        <div
          className="mb-10 font-body text-justify"
          dangerouslySetInnerHTML={{ __html: leader.body?.value || "" }}
        />
      </div>

      <div className="bg-gray-300 pb-8">
        <div className="container mx-auto px-4 md:px-8 lg:px-12 xl:px-20 max-w-screen-xl pt-5">
          <h2 className="text-xl sm:text-2xl lg:text-3xl font-heading font-bold uppercase relative text-indian-red text-center section-heading">
            MORE LEADERS
            <div className="relative flex items-center justify-center line-with-image">
              <img
                src="/assets/SHIKSHA_Flower_SVG.svg"
                alt="headingflower"
                className="h-6 sm:h-6 lg:h-8 relative z-10 bg-gray-300 p-1 sm:p-2"
              />
            </div>
          </h2>
          <Slider {...sliderSettings} className="mt-[45px]">
            {leadershipData
              .filter(
                (leader) =>
                  leader.path.split("/").pop() !== leaderId &&
                  leader.group?.name !== "CTO" &&
                  !uniqueTitles.has(leader.title) &&
                  uniqueTitles.add(leader.title)
              )
              .map((leader) => (
                <div key={leader.id} className="item text-center">
                  {/* Card Layout */}
                  <div
                    className="w-[300px] h-[440px] bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700 mx-auto flex flex-col"
                  >
                    {/* Image Section */}
                    <div className="w-full h-[200px] overflow-hidden rounded-t-lg bg-gray-200">
                      <img
                        src={leader.imageAbout.url}
                        alt={leader.imageAbout.alt}
                        className="w-full h-full object-cover"
                      />
                    </div>

                    {/* Content Section */}
                    <div className="p-5 flex flex-col justify-between flex-1">
                      <div>
                        <h5 className="mb-1 text-xl font-bold tracking-tight text-gray-900 dark:text-white leading-snug line-clamp-2">
                          {leader.title}
                        </h5>
                        <p className="text-sm font-medium text-gray-700 dark:text-gray-300 line-clamp-2">
                          {leader.post}
                        </p>
                        <p className="mt-2 text-sm text-gray-500 dark:text-gray-400 line-clamp-5">
                          {leader.shortDescription}
                        </p>
                      </div>

                      {/* Button */}
                      <Link
                        to={`/${currentLanguage === "hi" ? "hi/" : ""}leadership/${leader.path.split("/").pop()}`}
                        className="inline-flex items-center px-4 py-2 text-sm font-medium text-white bg-warm-orange rounded-lg hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-navy-blue dark:hover:bg-blue-700 dark:focus:ring-blue-800 mx-auto mt-4"
                      >
                        Read more
                        <svg
                          className="w-3.5 h-3.5 ml-2"
                          aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 14 10"
                        >
                          <path
                            stroke="currentColor"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M1 5h12m0 0L9 1m4 4L9 9"
                          />
                        </svg>
                      </Link>

                    </div>
                  </div>

                </div>
              ))}
          </Slider>

        </div>
      </div>
    </div>
  );
};

export default LeadershipDetails;
